import { render, staticRenderFns } from "./Not_found.vue?vue&type=template&id=32e15f34&scoped=true&"
import script from "./Not_found.vue?vue&type=script&lang=js&"
export * from "./Not_found.vue?vue&type=script&lang=js&"
import style0 from "./Not_found.vue?vue&type=style&index=0&id=32e15f34&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "32e15f34",
  null
  
)

export default component.exports